import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import styles from '../../../pages/ProfilePage/profilePage.scss';
import { ClubCard, LoadingCard } from '../../cards';
import { getClubsData } from '../../../actions/profile-tab-actions';
import { getClickAttrs } from '../../Analytics/gtag';

const ClubsTabContent = ({ isCurrentUserProfile, isProfileIdUpdated, isUserLoggedIn }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { data, isLoading } = useSelector(({ profileTabData }) => profileTabData?.clubs);

    useEffect(() => {
        if (isUserLoggedIn && !data?.clubs && isProfileIdUpdated) {
            dispatch(getClubsData());
        }
    }, [data.clubs, isProfileIdUpdated, isUserLoggedIn]);

    return (
        <div className={`${styles.clubs}`}>
            <h6 className={`title`}>Clubs</h6>
            {isLoading ? (
                <div className="row">
                    <div className={`col-12 col-md-6`}>
                        <LoadingCard data-testid="profile.clubs-tab.loading-card" />
                    </div>
                </div>
            ) : (
                <>
                    {data?.clubs?.length > 0 ? (
                        <div className="row">
                            {data.clubs.map(club => (
                                <div
                                    className={`col-12`}
                                    key={club.id}
                                >
                                    <ClubCard
                                        club={club}
                                        force={{ cardView: true }}
                                        data-testid={`profile.clubs-tab.club-${club.id}`}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (isCurrentUserProfile ? (
                        <>
                            <div className={`${styles.placeHolderGrid}`}>
                                <div className={`${styles.overlay}`} />
                                <div className={`${styles.actionWrapper}`}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-sm text-uppercase`}
                                        onClick={() => {
                                            const url = `/search?type=clubs&startDate=${moment(new Date()).format('MM/DD/YYYY')}`;
                                            history.push(url);
                                        }}
                                        {...getClickAttrs({
                                            category: `Player Profile`,
                                            context: `Clubs tab - Find club`,
                                            location: 'Player Profile CTA',
                                        })}
                                    >
                                        Find club
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div>
                            <p className="text-center">
                                No clubs have been added yet <br />
                                Check back for clubs
                            </p>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default ClubsTabContent;
